var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    {
      style: { "margin-top": "-" + _vm.$store.getters.footerHeight + "px" },
      attrs: { dark: "", height: _vm.$store.getters.footerHeight }
    },
    [
      _c(
        "v-layout",
        { attrs: { "justify-center": "", column: "", wrap: "" } },
        [
          _c("span", [
            _c(
              "a",
              {
                style: _vm.linkColor,
                attrs: {
                  target: "_blank",
                  href: "https://github.com/GIScience/ors-map-client"
                }
              },
              [_vm._v("v" + _vm._s(_vm.appVersion))]
            ),
            _vm._v(" | © " + _vm._s(_vm.currentYear) + " "),
            _c("strong", [_vm._v(_vm._s(_vm.footerMainSiteName))])
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.$t("global.developedByIntro")) + "\n          "),
            _c(
              "a",
              {
                style: _vm.linkColor,
                attrs: {
                  target: "_blank",
                  title: _vm.$t("global.developedBy"),
                  href: _vm.footerLink
                }
              },
              [_vm._v(_vm._s(_vm.$t("global.developedBy")))]
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "link",
              style: _vm.linkColor,
              attrs: {
                title: _vm.$t("about.privacyPolicy"),
                href: _vm.constants.links.privacyPolicy,
                target: "_blank"
              }
            },
            [_vm._v(_vm._s(_vm.$t("about.privacyPolicy")))]
          ),
          _vm._v(" "),
          _c("v-spacer", { attrs: { shrink: "" } }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "link",
              style: _vm.linkColor,
              attrs: {
                title: _vm.$t("about.termsOfService"),
                href: _vm.constants.links.termsOfService,
                target: "_blank"
              }
            },
            [_vm._v(_vm._s(_vm.$t("about.termsOfService")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b28170c", { render: render, staticRenderFns: staticRenderFns })
  }
}